import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const CONTENTSQUARE_INTEGRATION_NAME = 'contentsquare';
export const ZContentsquareIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(CONTENTSQUARE_INTEGRATION_NAME),
    category: z.literal('analytics'),
    credentials: z.object({}).optional(),
    settings: z.object({}).optional(),
}).shape);
//# sourceMappingURL=contentsquare.js.map